import { NgModule } from '@angular/core';
import { EmptyStateComponent } from '@app/app/components/empty-state/empty-state.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { LoadersModule } from '../loaders/loaders.module';

@NgModule( {
  declarations: [
    EmptyStateComponent,
  ],
  imports: [
    MatCardModule,
    MatProgressSpinnerModule,
    CommonModule,
    LoadersModule,
  ],
  exports: [
    EmptyStateComponent,
  ],
} )
export class EmptyStateModule {
}
